import React, { useState } from 'react';
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import HeadphonesOutlinedIcon from "@mui/icons-material/HeadphonesOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";

import "./style.css";
const Contact = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        mobile: "",
        email: "",
        body: "",
        status:false,
    })
     const handleChange = (e) => {
  const { name, value, type, checked } = e.target;

  if (name === 'mobile') {
    // Allow only digits
    const numericValue = value.replace(/\D/, '');
    setFormData(prev => ({ ...prev, [name]: numericValue }));
    return;
  }

  setFormData(prev => ({
    ...prev,
    [name]: type === 'checkbox' ? checked : value,
  }));
};

    const handleSubmit = (e) => {
        e.preventDefault();

        // ✅ You can replace this with your API call or other logic
        // console.log("Submitted data:", formData);

        // Optional: Reset form
        setFormData({
            firstName: "",
            lastName: "",
            mobile: "",
            email: "",
            body: "",
            status: false,
        });
    };
    return (
        <div className='Container'>
            <h2>CONTACT US</h2>

            <form className='formBox' onSubmit={handleSubmit}>
                <div>
                    <label>
                        First Name
                        <input className='Ipt' name='firstName' placeholder='First Name'  value={formData.firstName} onChange={handleChange} />
                    </label>
                    <label>
                        Last Name
                        <input className='Ipt' name='lastName' placeholder='Last Name' value={formData.lastName} onChange={handleChange} />
                    </label>
                </div>
                <label>
                    Email
                    <input className='Ipt' type='email' name='email' placeholder='Email' value={formData.email} onChange={handleChange} />
                </label>
                <label>
                    Mobile
                    <input className='Ipt' type='tel' name='mobile' placeholder='Mobile' value={formData.mobile} onChange={handleChange} pattern="[0-9]{10}" maxLength={10} required />
                </label>
                <label>
                    Discription
                    <textarea className='Ipt' name='body' placeholder='Enter Querys...' value={formData.body} onChange={handleChange} />
                </label>
                 <div className='checkFlex'>
                    <input type='checkbox' className='Ipt2' name='status' placeholder='status' checked={formData.status} onChange={handleChange} />
                   <p>"I Consent to reciving RCS,Whatsapp,Email or SMS from ganpatitraders.online & i have reviewed and agrre to terms & Condition, and Privacy Policy"</p>
                 </div>
                <button type='submit' id='IptBtn'>Submit</button>

            </form>
            <div className='address'>

                <p>
                    <LocationOnOutlinedIcon /> <strong>Address</strong>:     Ward No. 10, BANIYA, Kuchor Athooni, Bikaner (Raj.), 334202
</p>
                <p>
                    <HeadphonesOutlinedIcon /> <strong>Call Us:</strong> (+91) -
                    8209393590{" "}
                </p>
                <p>
                    <EmailOutlinedIcon /> <strong>Email:</strong> info@ganpatitraders.online
                </p>
                <p>
                    <WatchLaterOutlinedIcon /> <strong>Hours:</strong> 10:00 -
                    18:00, Mon - Sat
                </p>
           
        </div>
        </div >
    )
}

export default Contact;